import React from "react";

/** https://youtu.be/wqYvCHGbghE */
export const FUNNEL_YOUTUBE_ID = "wqYvCHGbghE";

export default function FunnelVideo({ showChecks = false }) {
  const embedSrc = `https://www.youtube.com/embed/${FUNNEL_YOUTUBE_ID}?rel=0&modestbranding=1`;

  return (
    <div className="add-link-funnel-video-inner">
      <iframe
        src={embedSrc}
        title="Chilll home diagnosis help"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
      {showChecks && (
        <ul className="add-link-funnel-video-checks" aria-hidden>
          <li>No app needed ✓</li>
          <li>No login ✓</li>
          <li>100% Free ✓</li>
        </ul>
      )}
    </div>
  );
}
